import { SELECTORS } from './config';
import { LocationSearch } from './LocationSearch';

function init() {
    const locationSearchNodes = [...document.querySelectorAll(SELECTORS.COMPONENT)];

    if (locationSearchNodes) {
        locationSearchNodes.forEach((node) => {
            // eslint-disable-next-line no-new
            new LocationSearch(node);
        });
    }
}

export default init;
